import { FINAL_ICON_LIBRARY } from "../../utils/finalIconMap";
import "./style.scss";

interface DynamicIconProps {
    name: string;
    colors?: string[];
    style?: React.CSSProperties;
}

const DynamicIcon = ({ name, colors, style }: DynamicIconProps) => {
    const icon = FINAL_ICON_LIBRARY[name]?.getIcon(colors);

    return (
        <div className="dynamic-icon-wrapper" style={style}>
            {icon}
        </div>
    );
};

export default DynamicIcon;
